import { AxiosInstance } from 'axios';

export interface IToken {
  id: string;
  token: string;
  userId: string;
  issuedAt: number;
  expiredAt: number;
}

export interface ICreds {
  access?: IToken;
  refresh?: IToken;
}

export interface IJwtInterceptorsConfig {
  axios: AxiosInstance;
  refreshTokenEndpoint: string;
}

export enum ETokenStatus {
  Expired = 10,
  Bad = 11,
  Incorrect = 12,
  Revoked = 13,
  BadSignature = 14,
}

export const LS_CREDS_KEY = 'creds';
export const PRE_REFRESH_PERIOD_SEC = 10;
export const REFRESH_TIMEOUT_MS = 5000;
